define(["backbone", "configuration/properties"], function (Backbone, Properties) {
  "use strict";

  const AiExpandResponseWithContextModel = {};

  AiExpandResponseWithContextModel.responseExpand = Backbone.Model.extend({
    defaults: {
      kbId: 0,
      intentId: 0,
      responseId: 0,
      text: "",
      targetLocaleId: 0,
    },
    url: function () {
      const kbId = this.get("kbId");
      const intentId = this.get("intentId");
      const responseId = this.get("responseId");
      return `${Properties.rootURL}/${kbId}/intents/${intentId}/responses/${responseId}/expandWithContext`;
    },
  });
  return AiExpandResponseWithContextModel;
});
